const people = {
    AndreEdwards: {
        title: 'Friends for life',
        body: [
            `From his early days as a summer intern in Audit with Doane Grant Thornton’s Antigua and Barbuda firm, Andre was amazed by how open everyone is. He saw that same welcoming and supportive culture when he joined the Halifax office in 2017 as a staff accountant and then again in Toronto, when he moved to our Advisory practice as a Senior Associate before becoming a manager in 2022. It’s helped him build close-knit bonds with people he considers to be friends for life – and strong relationships with leaders who are dedicated to helping him meet his goals on his unique career journey. Like becoming a partner in the next five to 10 years, where representation is also critical.`,
            `“Everyone wants to see people who look like them in leadership roles. My national team lead is a non-Caucasian woman, so I see there’s potential for someone like me to reach that level.” And building his career through the pandemic in a diverse and inclusive environment has been inspiring and makes him hopeful for the future, he says. “We’ve been through a lot of changes, but I believe people care about each other and want to work together so everyone succeeds. I see people are empathetic and emotionally aware and that will help the next generations get through anything.” <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Andre Edwards',
            job: 'Senior Manager, Transactions'
        },
        images: [
            {
                media: 'Andre_Edwards_1',
                type: 'image'
            },
            {
                media: 'Andre_Edwards_2',
                type: 'image'
            },
        ],
    },
    MarissaLam: {
        title: 'Work from the cottage',
        body: [
            `Marissa loves the sense of teamwork Doane Grant Thornton’s culture has. From leadership to her colleagues, Marissa feels supported pursuing any path she wants to take in her career. As an Associate, Risk and Forensics, she can talk to her leaders about the kind of work she enjoys most and do more of it – where and how she’d like. `,
            `Since the firm moved to a hybrid work model in early 2022, Marissa’s enjoyed the flexibility of working three days a week in the office and two from home. And since moving to Vancouver from Toronto, she’s been happy to be able to take advantage of the firm’s remote work benefits, and work from anywhere in Canada for up to four weeks during the summer months and for one additional week during the year.`,
            'It means no matter where she or her colleagues are located, she knows she can provide her clients with seamless services. It also means she can visit friends and family back in Ontario without using much of her vacation time to do it. “Or I can work from the cottage and build vacation into my work,” she says. “Having that flexibility really adds to my work life balance.” <strong>That’s our purple. Discover yours.</strong>',
        ],
        author: {
            name: 'Marissa Lam',
            job: 'Senior Associate, Risk & Forensics'
        },
        images: [
            {
                media: 'Marissa_Lam_1',
                type: 'image'
            },
            {
                media: 'Marissa_Lam_2',
                type: 'image'
            },
        ],
    },
    KellyHe: {
        title: 'A future filled with possibilities',
        body: [
            `Kelly joined the Privately Held Business Group practise at Doane Grant Thornton just before the pandemic started in 2020, so she didn’t really have the chance to get to know her colleagues before everyone moved online. Working as part of a virtual team was a bit of a challenge, but Kelly felt completely supported – and still does. Her group organized weekly virtual catch-up calls on Fridays, so Kelly and her fellow team members could learn a little more about each other. Then, when COVID restrictions loosened and it was safe, Kelly had the chance to get together with some Doane Grant Thornton colleagues for in-person lunches, to have even more opportunities to connect and learn. And she’s having monthly mentorship meetings with her People Manager, who coaches Kelly on project management and leadership skills to help her achieve her goals. It’s led to opportunities for Kelly to host some internal trainings for the entire team and manage a tax team of 15 people during busy season to enhance these skills. `,
            'So, while Kelly started her Doane Grant Thornton journey as a somewhat shy and introverted accountant, the firm’s supportive coaching culture has helped her create a future filled with possibilities. It’s empowered Kelly to be her best self at work – and in life. And Kelly couldn’t be happier about that. (And neither could we). <strong>That’s our purple. Discover yours.</strong>',
        ],
        author: {
            name: 'Kelly He',
            job: 'Manager, Independent Business Group'
        },
        images: [
            {
                media: 'Kelly_He_1',
                type: 'image'
            },
            {
                media: 'Kelly_He_2',
                type: 'image'
            },
        ],
    },
    BrittanieWilson: {
        title: 'Coaching for success',
        body: [
            `Doane Grant Thornton’s team culture has had a big impact on Brittanie’s Assurance role at the firm. She loves working with her teammates—“everyone is very helpful”—and getting together with them—“going for lunch is a great rest during tax season”. But it’s the coaching culture that’s had an even bigger impact on her career.`,
            `Every month, Brittanie meets with her people manager to talk about how her work and life are going, any challenges she’s facing, and how she’s doing with her professional goals. “She encourages me to use my goals to stretch more and push myself a little further,” she says. “I really like knowing she’s focusing on me and looking for ways for me to grow.”`,
            `Like when her people manager suggested Brittanie ask for feedback from colleagues and clients and apply it to her work. “I’ve never done that before,” she says. “Hearing positive feedback is always exciting and gives me confidence. And the constructive feedback shows me areas where I can improve and work toward achieving my goals. So I like hearing the positive and the constructive—both are very important to me.” <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Brittanie Wilson',
            job: 'Accountant, Independent Business Group'
        },
        images: [
            {
                media: 'Brittanie_Wilson_1',
                type: 'image'
            },
            {
                media: 'Brittanie_Wilson_2',
                type: 'image'
            },
        ],
    },
    JohnCalder: {
        title: 'Chasing the wind',
        body: [
            `<em class=em>With a flexible work environment, break time can be kitesurfing time.</em>`,
            `Flexibility comes in many forms. For John Calder, a Senior Manager in Professional Practice Group, Doane Grant Thornton offers the flexibility to move countries, take on new roles, and make time for the activities he’s passionate about.
            John began his career at the firm in the United Kingdom. He wanted to try living in a different country, and Canada offered a chance to engage in the outdoor sports that he loves. A two-year secondment to Kelowna became a permanent move as John discovered many opportunities and tons of adventure.`,
            `“I started off in the Audit practice in Kelowna,” he says, “and then tried doing more Independent Business Group (IBG)-type work, before finding a perfect match for my skill set with our Professional Practice Group. I love the variety of work and the problem-solving involved.”`,
            `This flexibility extends to balancing work with his personal passions, which include snowboarding and kitesurfing. `,
            `“We don’t get a lot of wind in Kelowna, so on the rare days that we do, it’s important to take advantage of it. Everyone I know who participates in this sport has some flexibility in their schedules, otherwise it just wouldn’t be possible.”`,
            `It’s that flexibility that allows John to create an amazing life fuelled by a rewarding career. “I can leave early to go kitesurfing when the wind comes up and then make up the time later in the day. Doane Grant Thornton offers me autonomy while trusting that I’ll still deliver an exceptional experience for my clients.” <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'John Calder',
            job: 'Senior Manager, Professional Practice Group'
        },
        images: [
            {
                media: '1_John_Calder',
                type: 'image'
            },
            {
                media: '2_John_Calder',
                type: 'image'
            },
        ],
    },
    GraceYeh: {
        title: `Aligning your career purpose with your soul’s purpose`,
        body: [
            `<em class=em>Who you are outside of work is who you can be inside of work. We’re proud to provide a workplace where you can belong and thrive.</em>`,
            `After becoming a CPA at Doane Grant Thornton, Grace was given the chance to explore other career opportunities within the firm. She ended up having the summer of her life on secondment with our Campus Recruiting team, which would eventually set her on her own unique career journey.`,
            `After her secondment, Grace left the firm for roles in industry, asset management, and consulting before deciding to combine her creative talent with her analytical skills and join our campus team permanently. And she’s so glad she did.`,
            `“I’ve just been so happy!” she says. “It took time to find the courage to pivot, but I have so much purpose now that I’ve aligned myself with my soul. I feel my career is limitless.” Grace uses analytical data and a creative eye to help rebrand our national campus campaigns.`,
            `And her new career is helping her thrive in her home life, too. It inspires her to dedicate time to Pilates classes and reading books and listening to podcasts on self-improvement. Her rewarding career helps fuel this amazing life, which includes devoting time to her favourite hobby—painting. She even takes on portrait commissions for family and friends. <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Grace Yeh',
            job: 'Manager, Talent Attraction [Campus]'
        },
        images: [
            {
                media: '2_Grace_Yeh',
                type: 'image'
            },
            {
                media: '1_Grace_Yeh',
                type: 'image'
            },
        ],
    },
    AlliCheng: {
        title: `Living at the edge of your comfort zone`,
        body: [
            `<em class=em>Leadership and growth starts with stepping out of your comfort zone and reaching new heights.</em>`,
            `Change can be scary. But having the courage to grow means stepping outside your comfort zone to embrace new challenges. And it’s about finding a place that offers you that chance. <br>Earlier this year, Alli Cheng reached out to her local Nanaimo partners and let them know she wanted to make a change. Before too long, she was offered a secondment in Halifax. “I told them what I was looking for and they not only listened, but they gave me exactly what I need to grow,” she says.`,
            `Over the years, she’s had many similar opportunities—whether it’s speaking in front of 300 tax professionals at a conference in British Columbia or taking part in one of our many coaching and leadership development programs, AdvantEdge.`,
            `Of that program, Alli says, “It speaks to Doane Grant Thornton’s culture and how we want to see colleagues grow. Many of us became accountants because we like accounting, but there is a whole other skill set you need to engage with clients, build relationships, and lead people. With the firm’s support, I’ve become a better advisor to my clients and coach to my teams. I’ve not only grown professionally, but personally. And I’ve been encouraged to take risks and step outside my comfort zone.”`,
            `In addition to taking on challenges at work, Alli climbs mountains in her spare time. “It reminds me a bit of my tax work and the experiences I’ve had at the firm. There’s a problem you need to work through, and you get an incredible sense of achievement when you see it through to the end.” <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Alli Cheng',
            job: 'Senior Manager, Tax'
        },
        images: [
            {
                media: '1_Alli_Cheng',
                type: 'image'
            },
            {
                media: '2_Alli_Cheng',
                type: 'image'
            },
        ],
    },
}

const student = [
[

{

    ...people.GraceYeh,
    slug: 'unique-career-journey',
    theme: 'two-photo',
    nav: {
        next: 'commitment-to-flexibility'
    }
},
{

    ...people.AlliCheng,
    slug: 'unique-career-journey',
    theme: 'two-photo',
    nav: {
        next: 'commitment-to-flexibility'
    }
},
{

    ...people.AndreEdwards,
    slug: 'unique-career-journey',
    theme: 'two-photo',
    nav: {
        next: 'commitment-to-flexibility'
    }
},
{

    slug: 'unique-career-journey',
    theme: 'one-photo',
    title: 'Everything he could ask for',
    body: [
        `<em class=em>Your career can transcend borders—across countries or the world. Discover your next journey with us.</em>`,
        `When Umang Parmar first arrived in Canada from India in 2019, he was looking for new career opportunities as well as friendships. He discovered both at Doane Grant Thornton.
        “I wasn’t even aware of other accounting firms when I first got here,” Umang, a Senior Accountant in our Assurance practice, says. He’d done his undergraduate degree in India and received his diploma in Canada in August, 2021. “I was fortunate that Doane Grant Thornton gave me a chance. I was initially hired to do bookkeeping for our corporate clients but once they saw what I was capable of, they started to give me more complex work.”`,
        `Umang began the Chartered Professional Accounting program and appreciates how much support he’s been given towards achieving his designation. “There’s so many great learning opportunities—the workshops and the instructors are really helpful,” Umang says. “And all my colleagues have been cheering me on and are quick to share their knowledge.”

        While he initially joined our Weyburn, Saskatchewan office, Umang wanted to experience a larger city, and Doane Grant Thornton facilitated his move to Saskatoon. He loves his new city and colleagues, saying, “I get excited every morning to go to work because I get to see my best buddies. Right from the start, they’ve included me in activities both inside and outside work, helping me feel like I belong. From the friendships to the many growth and learning opportunities, my experience at Doane Grant Thornton has been everything I could ask for.” <strong>That’s our purple. Discover yours.</strong>`,
    ],
    author: {
        name: 'Umang Parmar',
        job: 'Senior Accountant, Assurance'
    },
    images: [
        {
            media: 'Umang_Parmar_2',
            type: 'image'
        },
    ],
    nav: {
        next: 'commitment-to-flexibility'
    }
},

], [

{

    ...people.MarissaLam,
    slug: 'commitment-to-flexibility',
    theme: 'two-photo',
    nav: {
        prev: 'connect-and-learn-globally',
        next: 'coaching-culture'
    }

},

], [

{

    ...people.BrittanieWilson,
    slug: 'coaching-culture',
    theme: 'two-photo',
    nav: {
        prev: 'commitment-to-flexibility',
        next: 'your-cpa-journey'
    }

},
{

    ...people.KellyHe,
    slug: 'coaching-culture',
    theme: 'two-photo',
    nav: {
        prev: 'commitment-to-flexibility',
        next: 'your-cpa-journey'
    }

},

], [

{

    slug: 'your-cpa-journey',
    theme: 'staggered',
    title: 'Her success is our success',
    body: [
        `Having written the CFE exam in 2017, Kristen Miners knows what the two-year CPA process means. She understands how stressful each stage of completing modules, writing multiple choice tests and 5-hour long cases can be. And she knows what it feels like to get so wound up about it, you can lose focus. That’s why she coaches colleagues going through the process in the firm’s Calgary office, sharing insights that helped her pass everything on the first try. Like how important planning is when putting cases together, making sure each stage is complete and you’ve allotted enough time to finish them all. Or making sure to relax during your time off in the summer, so you balance your intense study periods with down time that lets you recover for the next stage. She enjoys her coaching so much, in fact, she plans to facilitate modules and mark cases for CPA Alberta in the future, to give back and help even more future professionals.`,
        'Kristen felt incredibly supported at every stage of her CPA journey at Doane Grant Thornton. From her colleagues and peers who helped answer questions to her coach who gave her invaluable survival tips to the partners who encouraged her to keep going. Her success is our success. And now she’s continuing that positive cycle for the next generation. <strong>That’s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Kristen Miners',
        job: 'Senior Manager, Transactions'
    },
    images: [
        {
            media: '1_Kristen_Miners',
            type: 'image'
        },
        {
            media: '2_Kristen_Miners',
            type: 'image'
        }
    ],
    nav: {
        prev: 'coaching-culture'
    }
},
{

    slug: 'your-cpa-journey',
    theme: 'one-photo',
    title: 'In the game of life, people make the difference',
    body: [
        `From the game room to the boardroom—with the support of our team, you can succeed anywhere. 
        Starting at Doane Grant Thornton right out of school in October 2023, Michelle Banha was nervous at the prospect of balancing a full-time job with studying for her Chartered Professional Accounting (CPA) designation. Now a Tax Analyst in our Edmonton office, Michelle appreciates that the firm creates a rich learning environment.
        “We have a great CPA training program, which provides a lot of structure, and everyone is so approachable and friendly. My mentor is also my people manager, and it’s helpful to work closely with someone who’s been in my shoes and can answer my questions,” says Michelle. She’s even embraced one of our key cultural values of leading with curiosity. “I was really nervous at first, but the more questions I ask, the better I feel.”`,
        `Michelle also finds time for the things that matter to her, including hanging out with friends and family, and volunteering in the community. “The fact that Doane Grant Thornton is so committed to our communities is important to me. Our Doane Grant Thornton Foundation has set up Greater Purpose Committees in each business unit to help identify opportunities to support our local communities. Right now, I’m working with our committee on a volunteer day for everyone in the office.”
        And whether it’s the end-of-season tax party, or an impromptu game of ping pong, there are lots of opportunities for fun. “The thing that most attracted me to Doane Grant Thornton was the people. Being surrounded by such a great group of colleagues, I feel like I can do anything.” <strong>That’s our purple. Discover yours.</strong>`,
    ],
    author: {
        name: 'Michelle Banha',
        job: 'Analyst, Tax'
    },
    images: [
        {
            media: 'Michelle_Banha_2',
            type: 'image'
        },
    ],
    nav: {
        prev: 'coaching-culture'
    }
},

]
]

const experienced = [
[

{

    ...people.GraceYeh,
    slug: 'unique-career-journey',
    theme: 'two-photo',
    nav: {
        next: 'commitment-to-flexibility'
    }
},
{

    ...people.AlliCheng,
    slug: 'unique-career-journey',
    theme: 'two-photo',
    nav: {
        next: 'commitment-to-flexibility'
    }
},
{

    ...people.AndreEdwards,
    slug: 'unique-career-journey',
    theme: 'two-photo',
    nav: {
        next: 'commitment-to-flexibility'
    }

},
{
    slug: 'unique-career-journey',
    theme: 'one-photo',
    single: true,
    title: 'Never looking back',
    body: [
        `Part way through her career in Grant Thornton’s Assurance practice in Sydney, NS, Blaire MacNeil was looking for a new challenge. Her people manager suggested she speak to a member of the firm’s Consumer Insolvency practice. Blaire had a taste of Insolvency work when she served part-time as Controller for a client in Nova Scotia, helping them overcome a difficult financial challenge. `,
        `She was curious about what a career in Insolvency might be like and thought a different experience just might provide the opportunity she was looking for. Speaking to colleagues in the practice gave her even more insights, especially around what it would be like to help individuals get a reset and gain control of their financial lives. After Grant Thornton gave her the opportunity to act on her curiosity, Blaire joined the Consumer Insolvency Business Unit in 2013 and later became a Licensed Insolvency Trustee. She has never looked back. Blaire finds the work incredibly rewarding, especially dealing with the more human side of accounting – helping people through what can often be a very difficult and emotional time.`,
        `Blaire’s advice for anyone exploring career options is, where possible, to first take it for a test drive. Talk to people in the field to understand what it takes to get there and imagine what your future will be like once you do. Blaire thrives today because Grant Thornton empowered her to create her own unique career journey. For Blaire, that means helping people overcome difficult personal challenges every day. <strong>That&rsquo;s our purple. Discover yours.</strong>`,
    ],
    author: {
        name: 'Blaire MacNeil',
        job: 'Partner, Debt Solutions'
    },
    images: [
        {
            media: 'Blaire_MacNeil',
            type: 'image'
        }
    ],
    nav: {
        next: 'commitment-to-flexibility'
    }

},

], [

{

    ...people.JohnCalder,
    slug: 'commitment-to-flexibility',
    theme: 'two-photo',
    nav: {
        prev: 'unique-career-journey',
        next: 'coaching-culture'
    }
},
{

    ...people.MarissaLam,
    slug: 'commitment-to-flexibility',
    theme: 'two-photo',
    nav: {
        prev: 'unique-career-journey',
        next: 'coaching-culture'
    }

},
{
    slug: 'commitment-to-flexibility',
    theme: 'video--single',
    title: 'Embracing Flexibility',
    body: [
        'Even as a university student, Angela Myers knew she wanted to have a career and a family – and chose accounting partly because she knew that with more education comes more options. That’s why in 2001, when Angela was pregnant and soon after Doane Grant Thornton announced we were extending the scope of our flexible work arrangements, she submitted a proposal to work 60 percent of the hours expected at her level as an Assurance Senior Manager. And she’s worked a flexible schedule ever since – including doing a compressed work week, putting in her hours remotely for the firm’s National office from Kentville, Nova Scotia, and working from home or, occasionally, while cheering on her daughter at sporting events around the province. She loves that her practice’s leaders have trust in her that she’ll get her job done – to a high standard – even if her hours don’t match up with the typical 9 to 5. In return, she increases her hours when she needs to and lets her team know about any changes in her schedule',
        'A flexible work arrangement gives Angela more time with her husband, who does shift work, and amazing chances to be there for her daughter’s biggest moments. Like when she got to see her receive the Top Student Award the last two years (for grades 9 and 10) at her high school closing. In the middle of the day. On a Friday. <strong>That’s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Angela Myers',
        job: 'Principal, National Quality'
    },
    images: [
        {
            media: 'Angela_Myers',
            type: 'video'
        }
    ],
    nav: {
        prev: 'unique-career-journey',
        next: 'coaching-culture'
    }
},
{
    slug: 'commitment-to-flexibility',
    theme: 'two-photo',
    title: 'Skype vs. Candlelight',
    body: [
        `When his wife, Natashia, got into the Dentistry program at McGill University, Tyler Krenz was looking at three years of having dinner with her over Skype instead of candlelight – or moving to Montreal from his hometown of Kelowna. Although he didn’t speak French, our Montreal office found a role for him serving Large Enterprise Audit clients that had subsidiaries in English-speaking cities like Calgary, Buffalo, and Sarasota. It offered lots of audit learning opportunities and travel, too. `,
        `Then, Tyler took another leap – this time into industry for one of the Montreal office’s global, privately held clients. He worked with colleagues across multiple time zones in places like Germany, Cypress and Luxemburg and learned a lot about what the audit was like from the client side – experience he put to great use when he rejoined Doane Grant Thornton in Kelowna as a Manager in our Advisory group, after Natashia finished her degree.`,
        'Doane Grant Thornton’s commitment to flexibility allowed him to take on roles that put him where he needed to be. All before coming full circle and bringing him back to his family in Kelowna. <strong>That’s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Tyler Krenz',
        job: 'Partner, Independent Business Group'
    },
    images: [
        {
            media: '1_Tyler_Krenz',
            type: 'image'
        },
        {
            media: '2_Tyler_Krenz',
            type: 'image'
        }
    ],
    nav: {
        prev: 'unique-career-journey',
        next: 'coaching-culture'
    }
},

], [

{

    ...people.BrittanieWilson,
    slug: 'coaching-culture',
    theme: 'two-photo',
    nav: {
        prev: 'coaching-culture'
    }

},
{

    ...people.KellyHe,
    slug: 'coaching-culture',
    theme: 'two-photo',
    nav: {
        prev: 'coaching-culture'
    }

},

], 
]

export default {
    experienced,
    student
}